import { useState } from 'react';
import axios from 'axios';
import { Truck, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Tracking() {
  const [orderId, setOrderId] = useState('');
  const [email, setEmail] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.get(`${API}/track/${orderId}`, { params: { email } });
      setResult(r.data);
    } catch { setResult(null); }
    setLoading(false);
  };

  return (
    <main data-testid="tracking-page" className="container-essenya py-20 max-w-2xl">
      <div className="text-eyebrow mb-3">Tracking</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Traccia il tuo ordine</h1>
      <p className="text-essenya-text mb-10">Inserisci numero ordine ed email per verificare lo stato della spedizione. Tempi standard: 2-3 giorni lavorativi.</p>
      <form onSubmit={submit} className="space-y-4 bg-white p-6 rounded-xl border border-essenya-border">
        <input value={orderId} onChange={e => setOrderId(e.target.value)} required placeholder="Numero ordine (es. ESS12345)" data-testid="tracking-order-id" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Email ordine" data-testid="tracking-email" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
        <button type="submit" disabled={loading} data-testid="tracking-submit" className="btn-primary w-full">{loading ? 'Verifica...' : 'Traccia ordine'}</button>
      </form>
      {result && (
        <div className="mt-8 bg-white p-6 rounded-xl border border-essenya-border" data-testid="tracking-result">
          <div className="flex items-center gap-3 mb-4">
            <Truck size={22} strokeWidth={1.5} />
            <div>
              <p className="font-medium">{result.tracking_number}</p>
              <p className="text-essenya-text text-sm">Stato: {result.status}</p>
            </div>
          </div>
          <div className="space-y-2">
            {result.steps.map((s, i) => (
              <div key={i} className="flex items-center gap-3 text-sm">
                <CheckCircle2 size={18} strokeWidth={1.5} className={s.done ? 'text-essenya-ink' : 'text-essenya-border'} />
                <span className={s.done ? '' : 'text-essenya-text'}>{s.label}</span>
              </div>
            ))}
          </div>
          <p className="text-essenya-text text-sm mt-4">Consegna stimata: {result.estimated_delivery}</p>
        </div>
      )}
    </main>
  );
}
